import { cn } from '@/utils';

interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className }: SkeletonProps) => (
  <div className={cn('animate-pulse rounded-xl bg-gray-200', className)} />
);

export const ProductCardSkeleton = () => (
  <div className="bg-white rounded-card shadow-card overflow-hidden">
    <Skeleton className="h-48 w-full rounded-none" />
    <div className="p-4 space-y-2">
      <Skeleton className="h-4 w-2/3" />
      <Skeleton className="h-3 w-1/3" />
      <Skeleton className="h-5 w-1/2" />
      <Skeleton className="h-10 w-full" />
    </div>
  </div>
);

export const OrderCardSkeleton = () => (
  <div className="bg-white rounded-card shadow-card p-6 space-y-3">
    <div className="flex justify-between">
      <Skeleton className="h-5 w-1/3" />
      <Skeleton className="h-5 w-1/4" />
    </div>
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-2/3" />
  </div>
);
